"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames4 = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _ExternalTeamPill = _interopRequireDefault(require("../ExternalTeamPill"));
var TeamIcon = function TeamIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0zM8.583 6.03a2.302 2.302 0 1 0 .016 4.566 1 1 0 1 1 .264 1.983 4.302 4.302 0 1 1-.03-8.533 1 1 0 1 1-.25 1.984zm3.738 8.503A7.001 7.001 0 0 1 22 21a1 1 0 1 1-2 0 5 5 0 1 0-10 0 1 1 0 1 1-2 0 7 7 0 0 1 4.321-6.467zm-4.338.383a1 1 0 0 1-.88 1.107A3.5 3.5 0 0 0 4 19.5a1 1 0 1 1-2 0 5.5 5.5 0 0 1 4.876-5.464 1 1 0 0 1 1.107.88z"
  }));
};
TeamIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "share-team": "SharedTeam__share-team__2gHe8",
  "shareTeam": "SharedTeam__share-team__2gHe8",
  "team-name": "SharedTeam__team-name__29XQ9",
  "teamName": "SharedTeam__team-name__29XQ9",
  "organization-name": "SharedTeam__organization-name__326e5",
  "organizationName": "SharedTeam__organization-name__326e5",
  "team-icon": "SharedTeam__team-icon__2qoI2",
  "teamIcon": "SharedTeam__team-icon__2qoI2",
  "removable-team": "SharedTeam__removable-team__vLHex",
  "removableTeam": "SharedTeam__removable-team__vLHex",
  "rendered-team": "SharedTeam__rendered-team__1rHSN",
  "renderedTeam": "SharedTeam__rendered-team__1rHSN"
}; 
require('./SharedTeam.css');
var SharedTeam = function SharedTeam(_ref) {
  var team = _ref.team;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "share-team",
    className: (0, _classnames4.default)(styles.shareTeam, (0, _defineProperty2.default)({}, styles.removableTeam, !!team.isMarkedAsDeleted))
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    role: "presentation",
    "data-test-id": "team-icon-sharing",
    className: (0, _classnames4.default)(styles.teamIcon, (0, _defineProperty2.default)({}, styles.removableTeam, !!team.isMarkedAsDeleted)),
    size: 20
  }, /*#__PURE__*/_react.default.createElement(TeamIcon, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames4.default)(styles.renderedTeam, (0, _defineProperty2.default)({}, styles.removableTeam, !!team.isMarkedAsDeleted))
  }, /*#__PURE__*/_react.default.createElement("div", {
    title: team.name,
    className: styles.teamName,
    "data-test-id": "share-asset-team-name"
  }, team.name, ' ', team.numberOfMembers ? /*#__PURE__*/_react.default.createElement("span", {
    "aria-label": "Number of members",
    "data-test-id": "share-asset-team-members-count"
  }, "(", team.numberOfMembers, ")") : null, team.type === 'external' ? /*#__PURE__*/_react.default.createElement(_ExternalTeamPill.default, {
    hasBeenShared: !!team.isMarkedAsDeleted
  }) : null), /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "share-asset-organization-name",
    className: styles.organizationName
  }, team.organization.name)));
};
SharedTeam.propTypes = {
  team: _propTypes.default.object.isRequired
};
var _default = exports.default = SharedTeam;
//# sourceMappingURL=SharedTeam.js.map